import { render, staticRenderFns } from "./AsiakasMuistiinpanotDatatable.vue?vue&type=template&id=6498b2be&"
import script from "./AsiakasMuistiinpanotDatatable.vue?vue&type=script&lang=js&"
export * from "./AsiakasMuistiinpanotDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6498b2be')) {
      api.createRecord('6498b2be', component.options)
    } else {
      api.reload('6498b2be', component.options)
    }
    module.hot.accept("./AsiakasMuistiinpanotDatatable.vue?vue&type=template&id=6498b2be&", function () {
      api.rerender('6498b2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsiakasMuistiinpanotDatatable.vue"
export default component.exports